/* eslint-disable import/prefer-default-export */
import { z } from 'zod/v3';

/**
 * webhookSchema - Validation schema for the webhook creation/edit form.
 *
 * @param {Function} t - Translation function.
 * @returns {z.ZodObject} - The zod schema.
 */
export const webhookSchema = (t) => z.object({
  name: z.string().min(1, t('errors.required')),
  target_url: z
    .string()
    .min(1, t('errors.required'))
    .refine(
      (url) => /^https?:\/\/.+/.test(url),
      { message: t('errors.invalid_url') }
    ),
  isActive: z.boolean().default(true),
  event_type: z.string().min(1, t('errors.required')),
  events: z.array(z.string()).min(1, t('errors.required')),
  jsonBody: z.string().min(1, t('errors.required')),
  headers: z.array(z.object({
    key: z.string().trim().min(1, t('errors.required')),
    value: z.string().trim().min(1, t('errors.required'))
  })).optional(),
  auth: z.discriminatedUnion('type', [
    z.object({
      type: z.literal('none'),
      config: z.any().optional()
    }),
    z.object({
      type: z.literal('apikey'),
      config: z.object({
        headerName: z.string().trim().min(1, t('errors.required')),
        apiKey: z.string().trim().min(1, t('errors.required'))
      })
    }),
    z.object({
      type: z.literal('oauth2'),
      config: z.object({
        clientId: z.string().trim().min(1, t('errors.required')),
        clientSecret: z.string().trim().min(1, t('errors.required')),
        refreshToken: z.string().trim().min(1, t('errors.required')),
        tokenUrl: z.string().trim().min(1, t('errors.required')).refine(
          (url) => /^https?:\/\/.+/.test(url),
          { message: t('errors.invalid_url') }
        )
      })
    })
  ]).optional().default({ type: 'none', config: {} })
});
